/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import serviceCall from '../serviceCall';
import { responseOkCode, n3000 } from './../../constant';

export function GetReportInformationLoading(data) {
  return { type: 'GET_REPORT_INFORMATION_LOADING', value: data };
}

export const getReportTreeAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(getReportTree(res.data));
    }
  });
export const deleteTankDetailsAction = (url, data, id) => dispatch =>
  serviceCall.deleteDataParams(url, data).then(() => {
    // Response
    dispatch(
      GetCastrolPdiTankTableDetails(
        `reportviewer/GetCastrolPdiTankTableDetails/${id}`,
      ),
    );
  });
export const deleteActionDetailsAction = (url, data, id) => dispatch =>
  serviceCall.deleteDataParams(url, data).then(() => {
    // Response
    dispatch(
      GetCastrolPdiActionTableDetails(
        `reportviewer/GetCastrolPdiActionTableDetails/${id}`,
      ),
    );
  });
export const getSeverityDetailListAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(getSeverityDetailList(res.data));
    }
  });
export const getReportIssueSummaryAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(getReportIssueSummary(res.data));
    }
  });
export const getReportSectionTaskDetailsAction = url => async dispatch => {
  dispatch({ type: 'TOGGLE_INDICATOR', value: true });

  try {
    const res = await serviceCall.getData(url);
    if (res.data) {
      dispatch(getReportSectionTaskData(res.data));
    } else {
      dispatch(getReportSectionTaskData([]));
    }

    return res.data;
  } catch (error) {
    console.error('Error fetching report section task details:', error);
    dispatch(getReportSectionTaskData([]));
  } finally {
    dispatch({ type: 'TOGGLE_INDICATOR', value: false });
  }
};
export const handleUnableToInspectAction = (url, data) => dispatch =>
  serviceCall.postData(url, data).then(() => {
    dispatch(
      getReportSectionTaskDetailsAction(
        `ReportViewer/GetReportSectionTasksDetails/${data.reportUuid}`,
      ),
    );
  });
export const getReportTaskDetailsAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(getReportTaskData(res.data));
    }
  });
export const getPanelCheckAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(getPanelCheck(res.data));
    }
  });
export const getPresignedUrl = data => dispatch =>
  serviceCall.postData('Reports/UploadPhotosWeb', data).then(response => {
    dispatch({
      type: 'PRESIGNEDURL',
      value: response.status === responseOkCode ? response.data : response,
    });
  });
export const addTankDetails = (data, id) => dispatch =>
  serviceCall.postData('reportviewer/AddTankDetails', data).then(() => {
    // Response
    dispatch(
      GetCastrolPdiTankTableDetails(
        `reportviewer/GetCastrolPdiTankTableDetails/${id}`,
      ),
    );
  });
export const updateTankDetails = (url, data, id) => dispatch =>
  serviceCall.putData(url, data).then(() => {
    dispatch(
      GetCastrolPdiTankAdditionalDetails(
        `reportviewer/GetCastrolPdiTemplateRecords/${id}`,
      ),
    );
  });

export const updateTankHeader = (url, data, id) => dispatch =>
  serviceCall.putData(url, data).then(() => {
    dispatch(
      GetCastrolPdiTemplateRecords(
        `reportviewer/GetCastrolPdiTemplateRecords/${id}`,
      ),
    );
  });
export const updateTankDetailsTable = (url, data, id) => dispatch =>
  serviceCall.putData(url, data).then(() => {
    dispatch(
      GetCastrolPdiTemplateRecords(
        `reportviewer/GetCastrolPdiTankAdditionalDetails/${id}`,
      ),
    );
  });
export const updateAssessmentDetails = (url, data, id) => dispatch =>
  serviceCall.putData(url, data).then(() => {
    dispatch(
      GetCastrolPdiTemplateRecords(
        `reportviewer/GetCastrolPdiTemplateRecords/${id}`,
      ),
    );
  });
export const addActionDetails = (data, id) => dispatch =>
  serviceCall.postData('reportviewer/AddActionDetails', data).then(() => {
    // Response
    dispatch(
      GetCastrolPdiActionTableDetails(
        `reportviewer/GetCastrolPdiActionTableDetails/${id}`,
      ),
    );
  });
export const addPhotoObservation = (url, data) => dispatch =>
  serviceCall.postData(url, data).then(response => {
    dispatch(getReportTaskData(response.data));
  });
export const deleteReportInReportViewer = (url, data) => dispatch =>
  serviceCall.deleteDataParams(url, data).then(response => {
    dispatch(deleteReportStatus(response.status));
  });
export const getCheckListTreeAction = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(getCheckListTree(response.data));
  });
export const deleteTaskObservation = (url, id) => dispatch =>
  serviceCall.deleteData(url, {}).then(response => {
    dispatch(getReportTaskData(response.data));

    dispatch(recalculateTopSeverityAction());
    // Removed full report refetch.
  });
export const reportDetailsUpdate = (url, data, onSuccess) => () =>
  serviceCall.putDataNew(url, data).then(r => {
    if (onSuccess) {
      onSuccess();
    }
    return r;
  });

export const updateTaskObservation = (url, data) => dispatch =>
  serviceCall.putData(url, data);

export const updateTaskObservationWithResponse = (
  url,
  data,
  recalculateTopSeverity = false,
) => async dispatch => {
  try {
    const response = await serviceCall.putData(url, data);
    dispatch(getReportTaskData(response.data)); // update redux.
    // If we have changed a field that requires recalculating the top severity, do it.
    if (recalculateTopSeverity) {
      dispatch(recalculateTopSeverityAction());
    }
    return response;
  } catch (error) {
    console.error('Failed to update observation:', error);
    throw error;
  }
};

export const getReportViewerHeaderDetails = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(getReportHeaderData(response.data));
  });
export const GetReportInformationCastrol = url => dispatch => {
  dispatch(GetReportInformationLoading(true));
  serviceCall.getData(url).then(response => {
    dispatch(GetReportInformationLoading(false));
    dispatch(GetReportInformationCastrolData(response.data));
  });
};
export const GetCastrolPdiTemplateRecords = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetCastrolPdiTemplateRecordsData(response.data));
  });

export const GetOnyxUkTemplateRecords = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetOnyxUkTemplateRecordsData(response.data));
  });
export const GetOnyxUkContactDetailsByReportId = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetOnyxUkContactDetailsByReportIdData(response.data));
  });
//
export const GetCastrolPdiTankTableDetails = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetCastrolPdiTankTableDetailsData(response.data));
  });
export const GetCastrolPdiActionTableDetails = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetCastrolPdiActionTableDetailsData(response.data));
  });
export const GetCastrolPdiTankAdditionalDetails = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetCastrolPdiTankAdditionalDetailsData(response.data));
  });
export const GetCastrolPdiAssesmentDetails = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetCastrolPdiAssesmentDetailsData(response.data));
  });
//
export const GetReportDL = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(GetReportDLData(response.data));
  });
export const handleReportIssueClosure = (url, data) => dispatch =>
  serviceCall.putDataWithParams(url, data).then(response => {
    dispatch(getReportIssueSummary(response.data));
  });
export const getReportTemperatureTrendingAction = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(getReportTemperatureTrending(response.data));
  });

export const getWpoContent = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(wpocontentdata(response.data));
  });
export const getS3Url = url => dispatch =>
  serviceCall.getData(url).then(response => {
    dispatch(S3Url(response.data));
    const res = response.data;
    if (res?.indexOf('.pdf') !== -1) {
      window.location.href = response.data;
      setTimeout(function() {
        window.close();
      }, n3000);
    }
  });
export function S3Url(data) {
  return { type: 'S3Url', value: data };
}
export function getReportTree(data) {
  return { type: 'REPORT_TREE', value: data };
}
export function getSeverityDetailList(data) {
  return { type: 'SEVERITY_DETAIL_LIST', value: data };
}
export function getReportIssueSummary(data) {
  return { type: 'REPORT_ISSUE_SUMMARY', value: data };
}
export function getReportSectionTaskData(data) {
  return { type: 'REPORT_SECTION_TASK_DATA', value: data };
}
export function getReportTaskData(data) {
  return { type: 'REPORT_TASK_DATA', value: data };
}
export function getCheckListTree(data) {
  return { type: 'CHECKLIST_TREE', value: data };
}
export function deleteReportStatus(data) {
  return { type: 'DELETE_REPORT_IN_REPORTVIEWER', value: data };
}
export function clearDeleteReportStatus() {
  return { type: 'CLEAR_DELETE_REPORT_IN_REPORTVIEWER' };
}
export function getReportHeaderData(data) {
  return { type: 'REPORT_HEADER_DATA', value: data };
}
export function GetReportInformationCastrolData(data) {
  return { type: 'GET_REPORT_INFORMATION_CASTROL_DATA', value: data };
}
export function GetCastrolPdiTemplateRecordsData(data) {
  return { type: 'GET_CASTROL_PDI_TEMPLATE_RECORDS_DATA', value: data };
}
export function GetOnyxUkTemplateRecordsData(data) {
  return { type: 'GET_ONYX_UK_TEMPLATE_RECORDS_DATA', value: data };
}
export function GetOnyxUkContactDetailsByReportIdData(data) {
  return { type: 'GET_ONYX_UK_CONTACT_DETAILS_BY_REPORT_ID_DATA', value: data };
}

//
export function GetCastrolPdiTankTableDetailsData(data) {
  return { type: 'GET_CASTROL_PDI_TANK_TABLE_DETAILS_DATA', value: data };
}
export function GetCastrolPdiActionTableDetailsData(data) {
  return { type: 'GET_CASTROL_PDI_ACTION_TABLE_DETAILS_DATA', value: data };
}
export function GetCastrolPdiTankAdditionalDetailsData(data) {
  return { type: 'GET_CASTROL_PDI_TANK_ADDITIONAL_DETAILS_DATA', value: data };
}
export function GetCastrolPdiAssesmentDetailsData(data) {
  return { type: 'GET_CASTROL_PDI_ASSESMENT_DETAILS', value: data };
}
//
export function GetReportDLData(data) {
  return { type: 'REPORT_DL_DATA', value: data };
}
export function getReportTemperatureTrending(data) {
  return { type: 'TEMPERATURE_TRENDING_CHART', value: data };
}
export function wpocontentdata(data) {
  return { type: 'GET_WPO_CONTENT', value: data };
}
export function getPanelCheck(data) {
  return { type: 'GET_PANEL_CHECK', value: data };
}

export function recalculateTopSeverityAction() {
  return { type: 'RECALCULATE_TOP_SEVERITY' };
}
